module.exports = "<span class=\"entity\" [title]=\"'Entidade ' + reportEntity.Alias\">({{reportEntity.Alias}})</span>"